import { Download } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { addBatchDrugToArea } from "../../../api/group";
import UploadIconParvandeh from "../../../assets/SVG/uploadIconParvandeh";
import CustomizedHook from "../../project/autocomplatePro";
import { getGroupAreas, getGroupTrips } from "../../../api/jahadgar";

const fileTypes = ["xlsx"];

function AddBatchDrugToArea({ setMode }) {
  const [file, setFile] = useState(null);
  const handleChange = (file) => {
    setFile(file);
  };
  const handleError = (err) => {
    console.log(err);
  };

  const [trips, setTrips] = useState();
  const [tripId, setTripId] = useState();
  const [areaId, setAreaId] = useState();
  const [areas, setAreas] = useState();

  useEffect(() => {
    getGroupTrips()
      .then((x) => {
        setTrips(x);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (tripId) {
      getGroupAreas(`?tripId=${tripId}`)
        .then((x) => {
          setAreas(x);
        })
        .catch(() => {});
    }
  }, [tripId]);
  const [rowErrors, setRowErrors] = useState();

  return (
    <>
      <Box mt={"30px"}>
        <Box display={"flex"} flexDirection={"row"} gap={"10px"}>
          {trips && (
            <CustomizedHook
              width={"300px"}
              multiple
              placeholder={"انتخاب کنید."}
              label="نام اردو"
              options={trips}
              onChange={(_, newValue) => {
                setTripId(
                  newValue && newValue.length > 0 ? newValue[0].id : undefined,
                );
              }}
            />
          )}
          {areas && (
            <CustomizedHook
              width={"300px"}
              multiple
              placeholder={"انتخاب کنید."}
              label="نام منطقه"
              options={areas}
              onChange={(_, newValue) => {
                setAreaId(
                  newValue && newValue.length > 0 ? newValue[0].id : undefined,
                );
              }}
            />
          )}
        </Box>
      </Box>
      <Box mt="20px">
        <Link
          style={{
            display: "flex",
            color: "var(--emr-darkblue)",
            marginTop: "20px",
          }}
          to={"https://statics.asar.app/add_drug_to_area_sample.xlsx"}
        >
          <Download size={"5"} color="blue" />
          <Typography>دانلود فایل نمونه</Typography>
        </Link>
      </Box>
      <FileUploader
        onError={handleError}
        handleChange={handleChange}
        label="فایل خود را اینجا قرار دهید"
        name="file"
        types={fileTypes}
      >
        <Box
          mt="20px"
          border={`solid 2px ${file ? "var(--emr-green)" : "#6C8C97"} `}
          borderRadius={"13px"}
          width={"calc( 100% - 40px )"}
          p="40px 20px"
          display="grid"
          justifyItems="center"
          sx={{ cursor: "pointer" }}
        >
          <Box mt="50px">
            <UploadIconParvandeh
              color={file ? "var(--emr-green)" : ""}
              size={"5"}
            />
          </Box>
          <p
            style={{
              marginTop: "50px",
              color: file ? "var(--emr-green)" : "#8B8B8B",
            }}
          >
            {file?.name || "فایل خود را اینجا بکشید یا انتخاب کنید"}
          </p>
        </Box>
      </FileUploader>
      {rowErrors && rowErrors.length > 0 && (
        <>
          <Typography variant="h2">لیست خطاها</Typography>
          {rowErrors.map((e, index) => (
            <Typography
              key={index}
            >{`${e["rowIndex"]}: ${e["errorMsg"]}`}</Typography>
          ))}
        </>
      )}
      <Box display={"flex"} justifyContent="end" mt="20px" gap={"20px"}>
        <button
          style={{
            border: "none",
            color: "white",
            background: "var(--emr-primary)",
            width: "130px",
            padding: "10px 0px",
            borderRadius: "10px",
          }}
          onClick={() => {
            if (!areaId) {
              toast.error("لطفا منطقه را تعیین کنید");
              return;
            }
            if (file) {
              const form = new FormData();
              form.append("file", file);

              addBatchDrugToArea(areaId, form)
                .then((x) => {
                  if (x.length > 0) {
                    setRowErrors(x);
                  } else {
                    setMode("table");
                  }
                })
                .catch(() => {});
            }
          }}
        >
          {"افزودن داروها به منطقه"}
        </button>
        <button
          style={{
            border: "none",
            color: "white",
            background: "#83122aff",
            width: "130px",
            padding: "10px 0px",
            borderRadius: "10px",
          }}
          onClick={() => setMode("table")}
        >
          انصراف
        </button>
      </Box>
    </>
  );
}

export default AddBatchDrugToArea;
